/**
 * @module MlbGameUtils/helpers
 * @desc Helper functions used by MlbGameUtils
 * @author Adam Pirani (adam.pirani@mlb.com)
 */

/**
 * Format the date displayed
 * @param {string} date string in statsApiGame (format YYYY-MM-DD-THH:MM:SSZ)
 * @param {object} mlbMoment Copy of MlbMomentTimezoneWrapper
 * @returns {string} Date formatted in lang equivalent of MMM D (ex: May 6)
 */
function formatInterruptionDate(date, mlbMoment) {

    let formattedDate = '';

    if (date) {

        let isTBD = date.indexOf('03:33:00Z') !== -1;

        if (mlbMoment) {

            let moment = mlbMoment.getMomentTimezone();
            let bamMomentLocales = mlbMoment.getBamMomentLocales();
            let mDay;

            if (isTBD) {

                mDay = moment(date.substr(0, 10));

            } else {

                mDay = moment(date);

            }

            formattedDate = mDay.format(bamMomentLocales.get_MMM_D());

        }

    }

    return formattedDate;

}


/**
 * @typedef dictionaryAndReplaceOpts
 * @type {object}
 * @property {function} translateFunction - Translate function (this._getTrans)
 * @property {string} dictionaryKey - Dictionary key with a key to be replaced (traditionally escaped with `{{` `}}`)
 * @property {string} dictionaryFallback - Fallback (English) text for that dictionary key
 * @property {string} replaceKey - Text in the string to be replaced
 * @property {string} replaceValue - Text that will be inserted in dictionary string
 */

/**
 * Look up a dictionary value and replace part of that text
 * @param {dictionaryAndReplaceOpts} opts
 * @returns {string}
 */
function dictionaryAndReplace(opts = {}) {

    const { translateFunction, dictionaryKey, dictionaryFallback = '', replaceKey = '', replaceValue = ''} = opts;

    return `${translateFunction(dictionaryKey, dictionaryFallback)}`.replace(replaceKey, replaceValue);

}

/**
 * Passed a browser window or a controller "req" object, returns the dictionary data
 * This overwrites the superclass bamGameUtils helper function
 * @param ctx
 */
function getDictFromContext(ctx) {
    if (ctx.i18n_dictionary) {
        // window:
        return ctx.i18n_dictionary;
    } else if (ctx.res && ctx.res.locals && ctx.res.locals.i18nDictionary && ctx.res.locals.i18nDictionary.dict) {
        // controller req:
        return ctx.res.locals.i18nDictionary.dict;
    } else {
        return {
            recap: 'Recap',
            watch: 'Watch',
            gameday: 'Gameday',
            preview: 'Preview',
            wrap: 'Wrap',
            boxscore: 'Boxscore',
            box: 'Box',
            tickets: 'Tickets',
            buysell: 'Buy/Sell',
            video: 'Video',
            mlbtv: 'MLB.tv',
            schedule: 'Schedule'
        };

    }
}

export { formatInterruptionDate, dictionaryAndReplace, getDictFromContext };
